import { memo } from "react";
import { SubtaskRow } from "./SubtaskRow";
import { replaceChildrenById } from "../lib/subtaskTree";

// Kök kardeş grubunun anahtarı (parentId === null durumu).
export const SUBTASK_ROOT_GROUP = "sub-root";

// AŞAMA 9 (Adım 1) — Alt görev sıralaması framer-motion'dan @dnd-kit'e taşındı.
// Sürükleme, görev listesinin ZATEN VAR OLAN tek `DragDropProvider`'ı üzerinden
// yürür (iç içe provider dnd-kit'te sürüklemeyi başlatmıyordu). Her ebeveynin
// çocukları ayrı bir `group`/`type` olduğundan bir alt görev YALNIZCA kendi
// kardeşleri arasında yer değiştirir — seviye değiştirme mümkün değildir.
// Kenar otomatik kaydırma hızı provider'da tanımlı ve görev kartıyla aynıdır
// (acceleration: 8, threshold: { x: 0, y: 0.2 }).
// Kullanıcı bu değeri onayladı — değiştirmeden önce sor.
function SubtaskTreeBase({ nodes = [], parentId = null, depth = 0, ctx }) {
  const group = parentId == null ? `${ctx.taskId}:${SUBTASK_ROOT_GROUP}` : `${ctx.taskId}:${parentId}`;
  return (
    <div className="space-y-1" data-subtask-group={group}>
      {nodes.map((s, i) => (
        <SubtaskRow key={s.id} sub={s} index={i} group={group} parentId={parentId} depth={depth} ctx={ctx} />
      ))}
    </div>
  );
}

export const SubtaskTree = memo(SubtaskTreeBase);

export { replaceChildrenById };
export default SubtaskTree;
